import React, { useState } from "react";
import { IconButton, Select, TableCell, TableRow } from "@mui/material";
import { CopyAllOutlined } from "@mui/icons-material";
import { BeaSearchResult } from "../../types/Bea/BeaSearchResult";
import MenuItem from "@mui/material/MenuItem";

type BeaSearchResultRowProps = {
  searchResult: BeaSearchResult;
  RowExtension?: (prop: { searchResult: BeaSearchResult; gender: string }) => JSX.Element;
};

export default function BeaSearchResultRow({ searchResult, RowExtension }: BeaSearchResultRowProps) {
  const [gender, setGender] = useState("");

  return (
    <>
      <TableRow sx={RowExtension ? { "& td": { border: "none", paddingBottom: 0 } } : {}}>
        <TableCell>
          <Select value={gender} onChange={(e) => setGender(e.target.value)} sx={{ minWidth: 80 }}>
            <MenuItem value={"female"}>Frau</MenuItem>
            <MenuItem value={"male"}>Herr</MenuItem>
          </Select>
        </TableCell>
        <TableCell>{`${searchResult.surname}${searchResult.firstname ? ", " + searchResult.firstname : ""}`}</TableCell>
        <TableCell>
          {searchResult.street} {searchResult.streetnumber}
        </TableCell>
        <TableCell>{searchResult.postalcode}</TableCell>
        <TableCell>{searchResult.city}</TableCell>
        <TableCell sx={{ wordBreak: "break-all" }}>
          {searchResult.safeId}{" "}
          <IconButton
            onClick={() => {
              navigator.clipboard.writeText(searchResult.safeId);
            }}
          >
            <CopyAllOutlined />
          </IconButton>
        </TableCell>
        <TableCell>{searchResult.type}</TableCell>
      </TableRow>
      {RowExtension ? <RowExtension searchResult={searchResult} gender={gender} /> : null}
    </>
  );
}
